import { useEffect } from 'react'
import { inject, observer } from 'mobx-react'
import _ from 'lodash'
import { withRouterProps } from '../../../utils'
import {
  ButtonsBox,
  HelpIcon,
  Spacer,
  Text,
  WizardStep,
  TooltipText,
  SVGWrapper,
  MultiLineButton,
} from '../../../components'
import { Warning } from '../../../assets/icons'
import { planTypeToAccountLabel, typeToAPI } from '../../../constants'
import { API } from '../../../api'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

const DuplicateChoice = styled(MultiLineButton)`
  width: 240px;
`

const accountTypeToItems = {
  '401k': ['basics', 'contributions', 'investments'],
  '403b': ['basics', 'contributions', 'investments'],
  '457': ['basics', 'contributions457', 'investments'],
  'payroll-deduct-ira': ['basics', 'contributions', 'investments'],
  '401a': ['basics', 'contributions', 'investments'],
  'keogh': ['basics', 'contributions', 'investments'],
  'sep-ira': ['basics', 'contributions', 'investments'],
  'simple-ira': ['basics', 'contributions', 'investments'],
  'ira-rollover': ['basics', 'contributionsIRA', 'investments'],
  'ira-roth': ['basics', 'contributionsIRA', 'investments'],
  'ira-deductible': ['basics', 'contributionsIRA', 'investments'],
  'ira-non-deductible': ['basics', 'contributionsIRA', 'investments'],
  'brokerage-account': ['basics', 'investments'],
  'other-asset': ['basics', 'investments'],
  'pension': ['basics', 'payout'],
  'annuity-fixed': ['basics', 'payout'],
}

const DuplicateAccount = props => {
  const { match, navigate, store, location } = props
  const { anotherRetirementAccount, deleteAccount, getAllPensions } = store
  const { accountType, type } = match.params

  useEffect(() => {
    // check that the type is actually correct
    if (!_.includes(_.keys(accountTypeToItems), accountType)) {
      navigate('/accounts/add', { replace: true })
    }
  }, [accountType, navigate])

  const handleDeleteAccount = async () => {
    await deleteAccount(anotherRetirementAccount.type, anotherRetirementAccount.id)
    await getAllPensions()
    props.navigate(`/accounts/add/${type}/${accountType}/basics`, {
      state: { id: location?.state?.id },
    })
  }

  const handleNext = async () => {
    try {
      await API.patch(typeToAPI[anotherRetirementAccount.type], {
        ...anotherRetirementAccount,
        contributionEligibility: false,
      })
      await props.store.getAccounts()
      await props.store.initializeActiveAccount()

      props.navigate(`/accounts/add/${type}/${accountType}/basics`, {
        state: { id: location?.state?.id },
      })
    } catch (err) {
      console.error(err)
    }
  }

  const title = `Is this a duplicate account?`

  return (
    <WizardStep title={title}>
      <Text
        style={{
          marginLeft: 15,
        }}>
        <div
          css={css`
            display: flex;
            & > div:nth-child(2) > span {
              display: flex;
              flex-direction: row-reverse;
            }
          `}>
          <SVGWrapper svg={Warning} fill='#3A4D57' size='large' />{' '}
          <HelpIcon tooltip={TooltipText.whyDoesThisMatter()}>
            <Text style={{ color: '#F48024', margin: '0px 8px' }}>Why does this matter?</Text>{' '}
          </HelpIcon>
        </div>
        <Spacer space='8px' />

        <Text>We think we may have found a duplicate account. Would you like to remove it?</Text>
        <Spacer space='8px' />

        <Text>
          {anotherRetirementAccount?.name}
          <br />
          {planTypeToAccountLabel[anotherRetirementAccount?.planType]}
        </Text>
        <ButtonsBox justifyContent='center'>
          <DuplicateChoice
            variant='tertiaryLight'
            onClick={handleDeleteAccount}
            label='Delete'
            sublabel="it's a duplicate"
          />

          <DuplicateChoice onClick={handleNext} label='Keep both' sublabel="it's not a duplicate" />
        </ButtonsBox>
      </Text>
    </WizardStep>
  )
}

export default withRouterProps(inject('store', 'account')(observer(DuplicateAccount)))
